import React from 'react';
import './styles.scss';
import cx from 'classnames';

const Spinner = ({ width, height, minWidth, minHeight, size, className }) => {
  return <div tabIndex={-1} className={cx('loader', className)} style={{ width, height, minWidth, minHeight, borderWidth: size }}></div>;
};

export default Spinner;
